import { useMemo } from 'react'

import { AuthService } from '@auth-portal/services'

export const useAuthService = (): AuthService => {
  return useMemo(() => AuthService.getOrCreate(), [])
}
